<svg class="main-svg" viewBox="0 0 26 25" xmlns="http://www.w3.org/2000/svg">
  <path class="svg-path" d="M0.777832 10.0556H25.2223V14.9445H0.777832V10.0556Z" />
  <path class="svg-path" d="M10.5556 24.7223V0.277832H15.4445V24.7223H10.5556Z" />
</svg>
